var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"max-auto course",attrs:{"to":{
    name: 'course-home',
    params: {
      courseUrlCode: _vm.urlCode
    }
  }}},[_c('v-img',{attrs:{"src":_vm.previewImg,"height":"200"}}),_c('v-card-subtitle',{staticClass:"d-flex justify-around align-center pb-0"},[_c('div',{staticClass:"flex-shrink-0 flex-grow-1 mr-3"},[_vm._v(" "+_vm._s(_vm.code.toUpperCase())+" ")]),_c('v-progress-linear',{attrs:{"value":_vm.progress,"color":"secondary","rounded":""}})],1),_c('v-card-title',{staticClass:"pt-1"},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }